/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const customerPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const customerPageResponseOutputItemsItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerPageResponseOutputItemsItemUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerPageResponseOutputItemsItemArchivedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerPageResponseOutputNextCursorOneMax = 512;

export const customerPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const CustomerPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(customerPageResponseOutputItemsItemIdRegExp),
      name: zod.string(),
      status: zod.enum(['active', 'archived']),
      version: zod
        .int()
        .gt(customerPageResponseOutputItemsItemVersionExclusiveMin)
        .max(customerPageResponseOutputItemsItemVersionMax),
      createdAt: zod.iso
        .datetime({ offset: true })
        .regex(customerPageResponseOutputItemsItemCreatedAtRegExp),
      updatedAt: zod.iso
        .datetime({ offset: true })
        .regex(customerPageResponseOutputItemsItemUpdatedAtRegExp),
      archivedAt: zod.union([
        zod.iso
          .datetime({ offset: true })
          .regex(customerPageResponseOutputItemsItemArchivedAtOneRegExp),
        zod.null(),
      ]),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(customerPageResponseOutputNextCursorOneMax)
      .regex(customerPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type CustomerPageResponseOutput = zod.input<typeof CustomerPageResponseOutput>;
export type CustomerPageResponseOutputOutput = zod.output<typeof CustomerPageResponseOutput>;
